<div class="container">
    <div fxLayout="row-reverse" class="close-button">
        <button mat-icon-button (click)="closeDialog()">
            <mat-icon>close</mat-icon>
        </button>
        <div fxLayout="row" fxLayoutAlign="end center" class="export-all">
            <button class="mat-button-iaqcharts" mat-raised-button (click)="exportAll()">
                Export
            </button>
        </div>
    </div>

    <mat-card-title class="mat-card-title">IAQ Charts</mat-card-title>
    <hr class="horizontal-line">

    <div fxLayout="column" fxLayoutAlign="center center" class="charts-container">
        <div fxLayout="row wrap" fxFlex="100" fxLayoutGap="60px">
            <mat-form-field appearance="outline" class="measure-selection">
                <mat-label>Select Measure</mat-label>
                <mat-select [(value)]="selectedMeasuresList" (selectionChange)="selectMeasure($event.value)" multiple>
                    <mat-option value="temperature">Temperature</mat-option>
                    <mat-option value="tvoc">TVOC</mat-option>
                    <mat-option value="humidity">Humidity</mat-option>
                    <mat-option value="mold">Mold Risk</mat-option>
                    <mat-option value="thermal_comfort_score">Thermal Comfort</mat-option>
                </mat-select>
            </mat-form-field>

            <div *ngIf="selectedMeasure" class="filter-bar" fxLayout="row">
                <button *ngFor="let range of ['1D', '7D', '30D']" [ngClass]="{'active': selectedDuration === range}"
                    (click)="selectAgoDuration(range)">
                    {{ range }}
                </button>
            </div>

            <div fxLayout="column">
                <mat-form-field appearance="outline" class="mat-form-field">
                    <mat-label class="mat-form-field-placeholder">Start Date - End Date</mat-label>
                    <mat-date-range-input [rangePicker]="rangePicker">
                        <input matStartDate class="start-date" placeholder="MM/DD/YYYY" [(ngModel)]="enteredStartDate"
                            [min]="minDate" name="enteredStartDate" readonly>
                        <input matEndDate class="end-date" placeholder="MM/DD/YYYY" [(ngModel)]="enteredEndDate"
                            [min]="enteredStartDate" name="enteredEndDate" (ngModelChange)="validateDateRange()"
                            readonly>
                    </mat-date-range-input>
                    <mat-datepicker-toggle matIconSuffix [for]="rangePicker"></mat-datepicker-toggle>
                    <mat-date-range-picker #rangePicker>
                        <mat-date-range-picker-actions>
                            <button mat-button matDateRangePickerCancel class="calendar-cancel-button">Cancel</button>
                            <button mat-raised-button class="apply-button" matDateRangePickerApply>Apply</button>
                        </mat-date-range-picker-actions>
                    </mat-date-range-picker>
                </mat-form-field>
            </div>
        </div>

        <div *ngIf="updateCharts && selectedDeviceIDs.length > 0 && selectedMeasuresList.length > 0" class="chart-item">
            <div *ngFor="let measures of selectedMeasuresList; let i = index" class="chart-wrapper">
                <app-chart 
                    [selectedDeviceIDs]="selectedDeviceIDs" 
                    [selectedMeasure]="measures"
                    [selectedDuration]="selectedDuration" 
                    [iaqDevices]="iaqDevices"
                    [formattedStartDate]="formattedStartDate" 
                    [formattedEndDate]="formattedEndDate"
                    (expandChart)="openChartFullscreen($event)">
                </app-chart>
            </div>
        </div>

        <div class="item-list">
            <div class="item" *ngFor="let device of iaqDevices; let i = index" [class.selected]="device.selected"
                [ngStyle]="{ 'background-color': device.color }" (click)="toggleSelection(i, $event)">
                <input class="item-checkbox" type="checkbox" [checked]="device.selected"
                    (click)="toggleSelection(i, $event)" />
                <span>{{ device.label }}</span>
            </div>
        </div>
    </div>
</div>